/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftAlert from "components/SoftAlert";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import Socials from "layouts/authentication/components/Socials";
import Separator from "layouts/authentication/components/Separator";

// Images
import curved6 from "assets/images/stock/background.jpeg";

let apiUrl = 'https://api.getverceipt.com/api/v1'

function SignUp() {
  const [agreement, setAgreement] = useState(false);

  const handleSetAgreement = () => setAgreement(!agreement);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loggedIn, setLoggedIn] = React.useState(false);

  const [loginError, setLoginError] = useState(false);

  const [treesSaved, setTreesSaved] = useState(0);

  useEffect(() => {
    const fetchTrees = async () => {
      try {
        const response = await fetch(`${apiUrl}/dashboard/analytics/environment/trees-saved/total`, {
          method: 'GET',
          credentials: 'include', // handles cookies
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) { // shorthand for response.status >= 200 && < 300
          const data = await response.json();
          console.log(data);

          setTreesSaved(data.treesSaved);
        } else {
          console.error('Error fetching trees:', response.status);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };

    fetchTrees();
  }, []);

  const onSignIn = async () => {
    try {
      await fetch(`${apiUrl}/dashboard/user/login`, {
        method: 'POST',
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username: username, password: password, remember_me: agreement })
      })
      .then(response => {
        if(response.status === 401) {
          setUsername('');
          setPassword('');
          setLoginError(true);
        } else if(response.status === 200) {
          window.location.reload(true);
        }
      })
    }
    catch (error) {
      console.error('Error attempting login for user', error);
      setLoginError(true);
    }

    console.log(username, password);
    
  };

  return (
    <BasicLayout
      title=""
      description="Use your provided credentials to access the admin panel."
      image={curved6}
    >
      <Card>
        <SoftBox p={3} mb={1} textAlign="center">
          <SoftTypography variant="h5" fontWeight="medium">
            Login
          </SoftTypography>
        </SoftBox>
        {/*<SoftBox mb={2}>
          <Socials />
        </SoftBox>
        <Separator />*/}
        <SoftBox pt={2} pb={3} px={3}>
          <SoftBox component="form" role="form">
            <SoftBox mb={2}>
              <SoftInput placeholder="Username or email" value={username} onChange={(e) => setUsername(e.target.value)} />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftInput type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} error={loginError} />
            </SoftBox>
            <SoftBox display="flex" alignItems="center">
              <Checkbox checked={agreement} onChange={handleSetAgreement} />
              <SoftTypography
                variant="button"
                fontWeight="regular"
                onClick={handleSetAgreement}
                sx={{ cursor: "poiner", userSelect: "none" }}
              >
                &nbsp;&nbsp;Remember me
              </SoftTypography>
            </SoftBox>
            <SoftBox mt={4} mb={1}>
              <SoftButton variant="gradient" color="dark" fullWidth onClick={() => onSignIn()}>
                sign in
              </SoftButton>
            </SoftBox>
            <SoftBox mt={3} textAlign="center">
              <SoftTypography variant="button" color="text" fontWeight="regular">
                🌳 0 trees have been saved so far
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </Card>
    </BasicLayout>
  );
}

export default SignUp;
